<div class="page-title">
    <vwui-tooltip position="bottom" [label]="'BUTTON.back' | translate">
        <button type="button" class="back-button" (click)="back.emit()" [attr.aria-label]="'BUTTON.back' | translate">
            <vwui-icon iconName="back"></vwui-icon>
        </button>
    </vwui-tooltip>
    <ng-content></ng-content>
</div>
